/* eslint-disable quote-props, max-len */

export default {
  'season': ({ seasonNumber }) => `Season ${seasonNumber}`,
  'episode': ({ episodeNumber }) => `Episode ${episodeNumber}`,
  'parentalControl.enterPin': 'We are protecting your children. Enter verification code to watch',
  'adInfo': ({ ads, adsCount }) => `Advert ${ads} of ${adsCount}`,
  'visitAd': 'Visit advertiser',
  'skipAd': 'Skip',
  'skipAdInTime': ({ time }) => `Skip in ${time}`,
  'chromecast.castingTo': 'Casting to',
  'chromecast.onboardingLabel': 'Cast to your TV',
  'playerSettings.audio': 'Audio',
  'playerSettings.subtitles': 'Subtitles',
  'playerSettings.quality': 'Quality',
  'playerSettings.off': 'Off',
  'playerSettings.auto': 'Automatic',
  'playerSettings.high': 'High',
  'playerSettings.medium': 'Medium',
  'playerSettings.low': 'Low',
  'playerError.noSubscription': 'Video unavailable with your subscription',
  'playerError.countryPermission': 'Video unavailable in this region',
  'playerError.trafficOverload': 'The service is experiencing high traffic. Try again later.',
  'playerError.upgradeSubscription': 'Video unavailable with your subscription',
  'playerError.notAvailable': 'Video unavailable',
  'playerError.noLongerAvailable': 'Video no longer available',
  'playerError.anotherPlayer': 'You are watching this video on another browser, tab, or device. Close the other video and try again.',
  'playerError.verifyEmail': 'Verify your email to watch this video',
  'playerError.parentalControl': 'Video unavailable due to parental control',
  'playerError.wrongPIN': 'Incorrect verification code. Try again.',
  'playerError.cannotChromecast': 'Can’t chromecast this video',
  'playerError.tooManyDevices': 'Too many registered devices. Clear the list in your account settings.',
  'playerError.enterPostcode': 'Enter your postcode',
  'playerError.wrongRegion': 'Service unavailable in this region',
  'playerError.noDRM': 'Protected video can’t be shown on this device',
  'playerError.noLiveRights': 'Video unavailable for live viewing',
  'playerError.browser': 'Your browser cannot read the content. Try reinstalling your browser or using a different one.',
  'playerError.adblockerDetected': 'To play video please disable ad-block or check network connection',
  'playerError.entitlementUnauthorized': 'Session expired. Try again after logging out and logging in.',
  'playerError.forbiddenProxy': 'Video unavailable when using a proxy or VPN',
  'playerError.licenseRejected': 'Due to license restrictions, this channel is not supported on this browser.',
  'playerError.outputRestricted': 'Due to license restrictions, playback is not supported on this display.',
  'playerError.serverError': ({ code }) => `A network request failed with status code ${code}. Please try again.`,
  'playerError.networkError': 'A network request failed, but not on the server. Please try again.',
  'playerOverlays.pauseOverlay': 'The video will resume at the live point',
  'error': 'An error occurred. Try again.',
  'nextVideo.label': 'Next episode',
  'nextVideo.timer': ({ time }) => `in ${time}`,
  'nextVideo.watchCredits': 'Watch credits',
};
